import { MoviePoster } from '@/types/movie-poster';
import { TheaterShowtimeItem } from '@/types/showtimes';
import { Movie, Theater } from '@cinemark/content-api-client';
import { isAfter, isBefore } from 'date-fns';
import { dateTimeMinTimeValue } from './date-time-helper';
import { normalizeMediaFileUrl } from './media-file-url';

export const hasAdvanceTickets = (startDate?: Date, endDate?: Date): boolean => {
  const now = new Date();

  return !!(startDate && endDate
    && startDate.getTime() !== dateTimeMinTimeValue && endDate.getTime() !== dateTimeMinTimeValue
    && isBefore(startDate, now) && isAfter(endDate, now) && isBefore(startDate, endDate));
};

export const getRuntimeString = (runtimeInMinutes?: number): string => {
  if (!runtimeInMinutes) return '';

  const hours = Math.floor(runtimeInMinutes / 60);
  const minutes = runtimeInMinutes % 60;

  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return `${hours} hr`;

  return `${hours} hr ${minutes} min`;
};

export const movieToMoviePoster = (movie: Movie, dataLinkCategory: string, theater?: Theater): MoviePoster => {
  const poster = movie.posterLargeImage || movie.posterMediumImage || movie.posterSmallImage;
  const posterUrl = poster?.url ? normalizeMediaFileUrl(poster.url) : undefined;

  return {
    cinemarkMovieId: movie.cinemarkMovieId || 0,
    dataLinkCategory,
    movieId: movie.movieId || 0,
    moviePosterAlt: `${movie.movieTitle} Poster`,
    moviePosterUrl: posterUrl,
    movieRating: movie.rating,
    movieReleaseDate: movie.releaseDate,
    movieRuntime: getRuntimeString(movie.runningTime),
    movieTitle: movie.movieTitle,
    movieTitleAttributeList: movie.movieTitleAttributes || [],
    movieTrailerUrl: movie.trailers?.[0]?.highResUrl || movie.trailers?.[0]?.lowResUrl,
    movieUrl: `/movies/${movie.slug}`,
    publicOnSaleDate: movie.publicOnSaleDate,
    theaterId: theater?.theaterId || 0,
    theaterName: theater?.theaterName || '',
  };
};

export const theaterShowtimeToMoviePoster = (showtimeItem: TheaterShowtimeItem, dataLinkCategory: string): MoviePoster => {
  return {
    cinemarkMovieId: showtimeItem.cinemarkMovieId,
    dataLinkCategory,
    movieId: showtimeItem.movieId,
    moviePosterAlt: `${showtimeItem.movieTitle} Poster`,
    moviePosterUrl: showtimeItem.moviePosterUrl,
    movieRating: showtimeItem.movieRating,
    movieReleaseDate: showtimeItem.movieReleaseDate,
    movieRuntime: showtimeItem.movieRuntime,
    movieTitle: showtimeItem.movieTitle,
    movieTitleAttributeList: showtimeItem.movieTitleAttributeList,
    movieUrl: `/movies/${showtimeItem.movieSlug}`,
    publicOnSaleDate: showtimeItem.publicOnSaleDate,
    theaterId: showtimeItem.theaterId,
    theaterName: '',
  };
};
